import moment from "moment";
import MultiSelectComponent from "../../../components/multi-select/multi-select.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import { DATE_TYPE_CODES, formats } from "../../../config/constants";
import CodeMasterModel from "../../../models/common/code-master.model";
import loginModel from "../../../models/login.model";
import ReportModel from "../../../models/report/report-model.model";
import ViewBase from "../../view-base.view";
export default function FfSelloutReportView() {
  ViewBase.call(this);

  const DEFAULT_FILTERS = {
    periodCode: DATE_TYPE_CODES.MONTH,
    toDate: moment().format(formats.API_MONTH_FORMAT),
    fromDate: moment().subtract(1, 'month').format(formats.API_MONTH_FORMAT),
    country: [],
    bu: '',
    business: []
  }

  const REPORT_FILTER_PARAMS = Object.freeze({
    dataSourceCode: '',
    periodCode: '',
    fromDate: '',
    toDate: '',
    xAxis: '',
    yAxis: '',
    zAxis: '',
    parameters: ''
  });

  let filters = structuredClone(DEFAULT_FILTERS);
  let currentFilter = {};
  // let iframeHeight = 300;
  const spacingHeight = 360;// 40 is the total height of margin/padding/scrollbar/header/search filter. Adjust accordingly if style changes. 
  let htmlRaw = '';
  let listBU = [];
  let listBusiness = [];
  let listCountry = [];
  let periodTypes = [{ code: 'M', name: 'Month' }/*,{code:'Q',name:'Quarter'},{code:'Y',name:'Year'}*/];
  let isCalc =false;

  const dataSourceCode = 'FFSelloutHtml';//m.route.param().dataSourceCode;    

  const buildParams = (isRaw) => {
    const params = structuredClone(REPORT_FILTER_PARAMS);

    params.countryCode = loginModel.credentials.country;
    params.dataSourceCode = dataSourceCode;
    params.periodCode = filters.periodCode;
    params.fromDate = filters.fromDate;
    params.toDate = filters.toDate;
    params.parameters = stringifyFilterParams(isRaw);
    return params;
  }

  const stringifyFilterParams = (isRaw) => {
    let sParams = '';
    if (filters.bu != '') sParams += '^^@FFBU:=' + filters.bu.code;
    if (filters.business.length > 0) sParams += '^^@FFPCType:=' + filters.business.join("^");
    if (filters.country.length > 0) sParams += '^^@Country:=' + filters.country.join("^");
    if (isRaw) sParams += '^^@IsRaw:=true';
    if (isCalc) sParams += '^^@IsCalc:=true';
    return sParams;
  }

  const renderDateInputLabel = () => {
    return periodTypes.find(x => x.code == filters.periodCode).name;
  }

  const DateInputComponentForMonth = () => {
    return {
      view: ({ attrs: { fromDateFilter, toDateFilter } }) => {
        return [
          m('.d-flex.position-relative',
            m('.position-relative',
              m('input#range.form-control[type="month"][required]', {
                name: fromDateFilter,
                // min: moment().add(getMinPeriod(), 'months').format(formats.MONTH_FORMAT),
                // max: moment().add(getMaxPeriod(), 'months').format(formats.MONTH_FORMAT),
                value: filters.fromDate
                  ? moment(filters.fromDate, formats.API_MONTH_FORMAT).format(formats.MONTH_FORMAT)
                  : null,
                onchange: (e) => {
                  let selectedDate = e.target.value
                    ? moment(e.target.value, formats.MONTH_FORMAT).format(formats.API_MONTH_FORMAT)
                    : null;
                  if (moment(selectedDate).isAfter(filters.toDate)) {
                    filters.toDate = null;
                  }
                  filters.fromDate = selectedDate;
                }
              }),
              m('.invalid-tooltip', this.getText('LT00000729', 'This field is required')),
            ),
            m('.px-2.my-auto', '~'),
            m('.position-relative',
              m('input#range2.form-control[type="month"][required]', {
                name: toDateFilter,
                // min: filters.fromDate
                //   ? moment(filters.fromDate, formats.API_MONTH_FORMAT).format(formats.MONTH_FORMAT)
                //   : moment().add(getMinPeriod(), 'months').format(formats.MONTH_FORMAT),
                // max: moment().add(getMaxPeriod(), 'months').format(formats.MONTH_FORMAT),
                value: filters.toDate
                  ? moment(filters.toDate, formats.API_MONTH_FORMAT).format(formats.MONTH_FORMAT)
                  : null,
                onchange: (e) => {
                  let selectedDate = e.target.value
                    ? moment(e.target.value, formats.MONTH_FORMAT).format(formats.API_MONTH_FORMAT)
                    : null;
                  filters.toDate = selectedDate;
                }
              }),
              m('.invalid-tooltip', this.getText('LT00000729', 'This field is required')),
            ),
          ),
        ]
      }
    }
  }

  const initializeReportPage = () => {
    filters = structuredClone(DEFAULT_FILTERS);
    setBUList();
    setBusinessList();
    setCountryList();
  }

  const setBUList = () => {
    CodeMasterModel.searchByCategoryV2('FFBU')
      .then(_data => {
        listBU = _data;
      });
  }
  const setBusinessList = () => {
    CodeMasterModel.searchByCategoryV2('FFPCType')
      .then(_data => {
        listBusiness = _data;
      });
  }
  const setCountryList = () => {
    CodeMasterModel.searchByCategoryV2('Country')
      .then(_data => {
        listCountry = _data;
      });
  }

  const search = (_reportParameter) => {
    this.showLoading();
    ReportModel.getReportHtmlData(_reportParameter, 'V2')
      .then((result) => {
        htmlRaw = result || '';
        _showAll();
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  const handleSearch = (e) => {
    if (!this.validateForm(e)) return false;

    currentFilter = structuredClone(filters);

    if (!e.target.checkValidity()) {
      showSiteSelectTooltip(!currentFilter.site);
      return;
    }

    search(buildParams(false));
  }

  const handleClearFilters = () => {
    filters = structuredClone(DEFAULT_FILTERS);
    htmlRaw = '';
    isAll = true;
    isQty = false;
    isAmt = false;
  }

  const handleDownloadExcel = (e) => {
    e.preventDefault();
    this.showLoading();

    ReportModel.downloadReportDataHtml(buildParams(true), `ff_${dataSourceCode}_${filters.fromDate}-${filters.toDate}.xls`, 'V2')
      .catch((error) => { this.handleError(error) })
      .finally(() => { this.hideLoading() })
  }

  var isAll = true, isQty = false, isAmt = false;
  let _showAll = () => {
    isAll = true;
    isQty = false;
    isAmt = false;
    toggleTable('qty', true, '1800pt');
    toggleTable('amt', true, '1800pt');
  }
  let _showQty = () => {
    isAll = false;
    isQty = true;
    isAmt = false;
    toggleTable('qty', true, '1000pt');
    toggleTable('amt', false, '1000pt');
  }
  let _showAmt = () => {
    isAll = false;
    isQty = false;
    isAmt = true;
    toggleTable('qty', false, '1000pt');
    toggleTable('amt', true, '1000pt');
  }

  let toggleTable = (cls, show, width) => {

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlRaw, 'text/html');

    const tbl = doc.getElementById('tblMain');
    tbl.style.width = width;

    const cols = Array.from(doc.getElementsByClassName(cls));
    cols.forEach(col => {
      col.style.display = show ? 'table-cell' : 'none';
    });

    htmlRaw = doc.documentElement.outerHTML;
  }

  return {
    oninit: () => {
      // getDataSourceCode();
      initializeReportPage();
    },
    onupdate: () => {
      // Re-initialize when nagivating to other report page
      isCalc = m.route.param().calc === 'calc';
    },
    view: () => {
      return [
        /* SEARCH */
        m('.d-flex.flex-column.align-items-end.gap-2.mb-3',
          m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="true"]',
            m('i.bi.bi-filter'),
            this.getText("LT00000232", "Filter"),
          ),
          m("#search-section.card.collapse.show.w-100",
            m(".card-body",
              m('form.needs-validation[novalidate]', { onsubmit: handleSearch },
                m('.row',
                  m('.col-md-7.col-lg-5.col-xl-4.position-relative',
                    m('label.form-label.mandatory[for=range]',
                      renderDateInputLabel()
                    ),
                    m(DateInputComponentForMonth, { fromDateFilter: 'fromDate', toDateFilter: 'toDate' }),
                  ),
                  m('.col-md-3.col-lg-2.col-xl-2.position-relative',
                    m('label.form-label', this.getText('LT00000188', 'Country')),
                    m(MultiSelectComponent, {
                      id: 'country',
                      items: listCountry,
                      selectedItems: filters.country,
                      keyOnly: true,
                      filterableByKey: true,
                      showKeyInLabel: true,
                      onSelect: (value) => {
                        filters.country = value;
                      }
                    }),
                  ),
                  m('.col-md-3.col-lg-2.col-xl-2.position-relative',
                    m('label.form-label[for=bu]', this.getText('LT00000239', 'BU')),
                    m(SingleSelectComponent, {
                      // disabled: listBUOptions.length == 0,
                      id: "bu",
                      items: listBU,
                      selectedItem: filters.bu,
                      onSelect: (value) => {
                        filters.bu = value;
                        if (value.code) {
                          filters.business = [];
                        }
                      },
                      // required: true,
                      allowEmpty: true,
                    }),
                  ),
                  m('.col-md-3.col-lg-2.col-xl-2.position-relative',
                    m('label.form-label[for=business]', 'Promoter Type'),
                    m(MultiSelectComponent, {
                      id: 'business',
                      items: listBusiness,
                      selectedItems: filters.business,
                      disabled: (filters.bu?.code === 'MX'),
                      activeIndex: filters.business.length ? undefined : 0,
                      keyOnly: true,
                      filterableByKey: true,
                      showKeyInLabel: false,
                      onSelect: (value) => {
                        filters.business = value;
                      }
                    }),
                  ),
                  // Search & clear buttons
                  m('.col-12.d-flex.justify-content-end.gap-2.mt-2',
                    m('button.btn.btn-primary', this.getText("LT00000001", "Search")),
                    m('button.btn.btn-white[type=button]',
                      { onclick: handleClearFilters },
                      this.getText("LT00000031", "Clear")
                    ),
                  ),
                )
              )
            )
          )
        ),
        /* TABLE */
        m('.card',
          m('.card-body',
            m('.d-flex.flex-wrap-reverse.justify-content-between.align-items-end.mb-2', { style: 'gap: 1.5em;' },
              m('.worktype-legend.d-flex.flex-grow-1',
                m('button.btn',
                  {
                    disabled: !htmlRaw,
                    class: isAll ? 'btn-primary' : 'btn-white',
                    onclick: _showAll,
                    style: "min-width: 100px; border-top-right-radius: 0; border-bottom-right-radius: 0;"
                  },
                  "All"
                ),
                m('button.btn',
                  {
                    disabled: !htmlRaw,
                    class: isQty ? 'btn-primary' : 'btn-white',
                    onclick: _showQty,
                    style: "min-width: 100px; border-top-left-radius: 0; border-bottom-left-radius: 0;border-top-right-radius: 0; border-bottom-right-radius: 0;"
                  },
                  "Quantity"
                ),
                m('button.btn',
                  {
                    disabled: !htmlRaw,
                    class: isAmt ? 'btn-primary' : 'btn-white',
                    onclick: _showAmt,
                    style: "min-width: 100px; border-top-left-radius: 0; border-bottom-left-radius: 0;"
                  },
                  "Amount"
                ),
              ),
              m('.d-flex.justify-content-end.flex-grow-1',
                m('button.btn.btn-primary',
                  {
                    disabled: !htmlRaw,
                    onclick: handleDownloadExcel
                  },
                  m('i.bi.bi-file-earmark-arrow-down'),
                  this.getText('LT00000492', 'Download')
                ),
              )
            ),
            m('.row.g-2',
              m('.col-12',
                htmlRaw ?
                  m('iframe', {
                    // onload: (e) => {
                    //   iframeHeight = e.target.contentWindow.document.body.scrollHeight + spacingHeight;
                    // },
                    id: 'preRenderedTable',
                    srcdoc: htmlRaw,
                    style: `width: 100%; height: calc(100vh - ${spacingHeight}px);`,
                  }) :
                  m("div",
                    { style: { 'text-align': "center" } },
                    this.getText("EM00000837", "Click search button to generate report.")
                  ),
              ),
            )
          )
        ),

        this.getBaseViews(),
      ];
    },
  };
}